export default __webpack_public_path__ + "media/images/avatars/avatar0-436aac8de9608100f32d0189c7988c81.png";